import React, { Component } from "react";

import Modal from "react-modal";
import YayScore from "./Yayscore";
import SettingSendText from "./settings_send_text";

import { ModalViewType } from "../../../helper/type_helper";

class YAYModalView extends Component {
  state = { show: false, show_view: false };

  componentDidMount() {
    const self = this;
    setTimeout(function() {
      self.setState({ show: true });
    }, 100);
  }

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    var style = { top: "-100px" };
    if (this.state.show === true) {
      style = { top: "0px" };
    }
    if (this.state.show_view === true) {
      return <div />;
    }
    return (
      <Modal className="follow-views" isOpen={true}>
        <div className="follow-return" onClick={this.handleCloseView} />
        <div style={style} className="follow-view center">
          {this.renderView()}
        </div>
      </Modal>
    );
  }

  handleCloseView = event => {
    this.setState({ show: false });
    const self = this;
    setTimeout(function() {
      self.props.handleCloseView();
    }, 600);
  };

  renderView() {
    switch (this.props.modalView) {
      case ModalViewType.yayscore:
        return <YayScore user={this.props.user} />;
      case ModalViewType.send_text:
        return (
          <SettingSendText
            user={this.props.user}
            handlerUpdateUser={this.props.handlerUpdateUser}
          />
        );
      default:
        return <div />;
    }
  }
}

export default YAYModalView;



// WEBPACK FOOTER //
// ./src/components/profile/modal/modal_view.jsx